import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";

const ApiService = {

    base: "/api/v1",

    init() {
        Vue.use(VueAxios, axios);
    },

    query(resource, params) {
        return Vue.axios.get(`/education-resources/api/v1/${resource}`, params).catch(error => {
            throw new Error(`ApiService::get ${error}`);
        });
    },

    list(resource) {
        return Vue.axios.get(`/education-resources/api/v1/${resource}`).catch(error => {
            throw new Error(`ApiService::list ${error}`);
        });
    },

    get(resource, slug = "") {
        return Vue.axios.get(`/education-resources/api/v1/${resource}/${slug}`).catch(error => {
            throw new Error(`ApiService::get ${error}`);
        });
    },

    post(resource, params) {
        return Vue.axios.post(`/education-resources/api/v1/${resource}`, params);
    },

    update(resource, slug, params) {
        return Vue.axios.put(`/education-resources/api/v1/${resource}/${slug}`, params);
    },

    put(resource, params) {
        return Vue.axios.put(`/education-resources/api/v1/${resource}`, params);
    },

    delete(resource) {
        return Vue.axios.delete(`/education-resources/api/v1/${resource}`).catch(error => {
            throw new Error(`ApiService::delete ${error}`);
        });
    }
};

export default ApiService;

export const FormatService = {
    list(lang) {
        return ApiService.list(`${lang}/vocabulary/formats/`);
    }
};

export const LanguageService = {
    list(lang) {
        return ApiService.list(`${lang}/vocabulary/languages/`);
    }
};

export const RecordSearchService = {
    search(lang, query, facets, filters) {
        var params = [];
        const items = [...facets, ...filters];

        if("q" in query) {
            params.push(["search=" + query.q]);
        }

        for(var i=0; i < items.length; i++) {
            let f = items[i];

            if(facets.indexOf(f) >= 0) {
                params.push(["facet=" + f]);
            }

            if(f in query) {
                if(query[f] instanceof Array) {
                    for(let j=0; j < query[f].length; j++) {
                        params.push([f + "=" + query[f][j]]);
                    }
                } else {
                    params.push([f + "=" + query[f]]);
                }
            }
        }

        if(params.length > 0) {
            return ApiService.list(lang + "/search/hrtk/records/?" + params.join("&"));
        } else {
            return ApiService.list(lang + "/search/hrtk/records/");
        }
    },
    searchNextPrev(url) {
        return ApiService.list(url);
    }
};
